<button class="button" fxHide fxShow.gt-sm mat-button fxFlex="grow" matTooltipClass="toolbar-info-tooltip" 
(click)="sendEmail()" matTooltip="support@youattest.com">
    <mat-icon>help_outline</mat-icon>
</button>    
